import { ModelSetTransformer, ModelTransformer } from '../common/common.model';

export interface ExtWidgetAttributeConfiguration {
    widgetDefinitionID: number;
    attributeName: string;
    attributeValue: string;
    attributeType: string;
}

export interface ExtWidgetConfiguration {
    tenantID: number;
    widgetDefinitionID: number;
    widgetTypeID: number;
    width: number;
    title: string;
    displayOrder: number;
    cssOverride: string;
    widgetMetricConfigurations: any[];
    widgetAttributeConfigurations: ExtWidgetAttributeConfiguration[];
}

export interface ExtWidgetGroup {
    tenantID: number;
    widgetGroupID: number;
    title: string;
    width: number;
    widgetConfigurationTypeID: number;
    widgetConfigurations: ExtWidgetConfiguration[];
    notDisplayWidgets: any[];
}

export interface WidgetAttribute {
    type: string;
    name: string;
    value: string;
}

export interface WidgetConfiguration {
    typeId: number;
    definitionId: number;
    title: string;
    width: number;
    cssClassOverride: string;
    attributes: WidgetAttribute[];
}

export interface WidgetGroup {
    width: number;
    configurations: WidgetConfiguration[];
}

class WidgetAttributeModelTransformer
    implements
        ModelTransformer<WidgetAttribute, ExtWidgetAttributeConfiguration>
{
    transform(model: ExtWidgetAttributeConfiguration): WidgetAttribute {
        return {
            type: model.attributeType,
            name: model.attributeName,
            value: model.attributeValue,
        };
    }
}

class WidgetAttributeModelSetTransformer extends ModelSetTransformer<
    WidgetAttribute,
    ExtWidgetAttributeConfiguration
> {
    protected newTransformer(): ModelTransformer<
        WidgetAttribute,
        ExtWidgetAttributeConfiguration
    > {
        return new WidgetAttributeModelTransformer();
    }
}

class WidgetConfigurationModelTransformer
    implements ModelTransformer<WidgetConfiguration, ExtWidgetConfiguration>
{
    transform(model: ExtWidgetConfiguration): WidgetConfiguration {
        const attributes = new WidgetAttributeModelSetTransformer().transform(
            model.widgetAttributeConfigurations,
        );
        return {
            typeId: model.widgetTypeID,
            definitionId: model.widgetDefinitionID,
            title: model.title,
            width: model.width,
            cssClassOverride: model.cssOverride,
            attributes,
        };
    }
}

class WidgetConfigurationModelSetTransformer extends ModelSetTransformer<
    WidgetConfiguration,
    ExtWidgetConfiguration
> {
    protected newTransformer(): ModelTransformer<
        WidgetConfiguration,
        ExtWidgetConfiguration
    > {
        return new WidgetConfigurationModelTransformer();
    }

    transform(model: ExtWidgetConfiguration[]): WidgetConfiguration[] {
        return super.transform(
            model.sort((a, b) => a.displayOrder - b.displayOrder),
        );
    }
}

export class WidgetGroupModelTransformer
    implements ModelTransformer<WidgetGroup, ExtWidgetGroup>
{
    transform(model: ExtWidgetGroup): WidgetGroup {
        const configurations =
            new WidgetConfigurationModelSetTransformer().transform(
                model.widgetConfigurations,
            );
        return {
            width: model.width,
            configurations,
        };
    }
}

export function validateWidgetGroup(model: WidgetGroup): void {
    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    const valid =
        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
        model != null &&
        model.configurations != null &&
        model.configurations.length !== 0;
    if (!valid) {
        throw new Error('WidgetGroup not valid');
    }
}
